import { Detection, HeldFeedField } from 'src/data-capture/types';

/**
 * The document values each connected asset a detection could update takes from the data feed
 * instead, by conflict id. The backend works these out, as a write to the asset would refuse or
 * ignore them.
 */
export const heldFeedFieldsByConflict = (detection: Detection): Record<string, HeldFeedField[]> =>
  Object.fromEntries(
    detection.conflicts
      .filter(conflict => (conflict.heldFeedFields ?? []).length > 0)
      .map(conflict => [
        String(conflict.conflictingEntityFields.id),
        conflict.heldFeedFields ?? [],
      ]),
  );
